import React from 'react';
import { Camera, Star, Zap } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-24 bg-stone-900 text-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <div className="order-2 lg:order-1" data-id="element-4">
            <img src="https://cdn.magicpatterns.com/uploads/vk5EWZSh2MyBeoHYAeKMMu/3.webp" alt="Calentadores negros de piel sintética con falda escalonada" className="w-full h-[700px] object-cover transition-all duration-700" data-id="element-5" />
          </div>

          <div className="order-1 lg:order-2 space-y-12" data-id="element-6">
            <div data-id="element-7">
              <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-8">
                Tu identidad está <br data-id="element-9" />
                <span className="italic text-stone-400" data-id="element-10">en los detalles.</span>
              </h2>
              <p className="text-lg text-stone-300 leading-relaxed" data-id="element-11">
                Vestirse para cubrirse es fácil. Vestirse para{' '}
                <strong className="text-white" data-id="element-12">expresarse</strong> exige piezas
                que los demás olvidan. Aura Polar es para quien entiende que el
                look no termina en los zapatos.
              </p>
            </div>

            <div className="space-y-8" data-id="element-13">
              <div className="flex gap-6 items-start" data-id="element-14">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-15">
                  <Zap className="w-6 h-6 text-white" data-id="element-16" />
                </div>
                <div data-id="element-17">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-18">
                    Transformación Instantánea
                  </h3>
                  <p className="text-stone-400" data-id="element-19">
                    Tus botas de siempre, con un nivel de pasarela.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-20">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-21">
                  <Camera className="w-6 h-6 text-white" data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-24">
                    100% Fotogénicos
                  </h3>
                  <p className="text-stone-400" data-id="element-25">
                    Diseñados para destacar en cámara.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-26">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-27">
                  <Star className="w-6 h-6 text-white" data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-30">
                    Calidad Premium
                  </h3>
                  <p className="text-stone-400" data-id="element-31">
                    No se aplastan ni pierden su brillo con el uso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}